/**
 * Complete event data
 */
type EventData = {
  userId: string
  userRole: string
  modelId?: string
  model?: EventModel
  personId?: string
  data?: EventCustomData
}

/**
 * Event params for Logger
 */
type EventParams = {
  modelId?: string
  model?: EventModel
  personId?: string
  data?: EventCustomData
}

/**
 * Custom values for event data
 */
type EventCustomData = {
  context?: string
  value?: string | object | number | boolean
  action?: string
  time?: number
  error?: object
  filters?: string[]
}

/**
 * Event modules
 */
enum EventModel {
  APPOINTMENT = 'APPOINTMENT',
  HEALTH_PLAN = 'HEALTH_PLAN',
  WANDA = 'WANDA',
  CHANNELS = 'CHANNELS',
  BUD = 'BUD',
  HEALTH_CARE_MAP = 'HEALTH_CARE_MAP',
  TERTIARY_CARE_MAP = 'TERTIARY_CARE_MAP',
  SECOND_OPINION = 'SECOND_OPINION',
  VIDEO_CALL = 'VIDEO_CALL',
  TIMELINE = 'TIMELINE',
  DEMANDS = 'DEMANDS',
  COCKPIT = 'COCKPIT',
  TEST_RESULT = 'TEST_RESULT',
  HEALTH_COMMUNITY = 'HEALTH_COMMUNITY',
  VIRTUAL_CLINIC = 'VIRTUAL_CLINIC',
  PELICANO = 'PELICANO',
  CLINICAL_PROFILE = 'CLINICAL_PROFILE',
  ACCREDITED_NETWORK = 'ACCREDITED_NETWORK',
  EMERGENCY_ROOM = 'EMERGENCY_ROOM',
  PROFILE = 'PROFILE'
}

/**
 *
 * Generic event name
 */
enum EventName {
  //User interactions
  USER_INTERACTION = 'USER_INTERACTION',
  USER_INTERACTION_HAI = 'USER_INTERACTION_HAI',
  USER_INTERACTION_MENU = 'USER_INTERACTION_MENU',
  USER_INTERACTION_MESSAGE = 'USER_INTERACTION_MESSAGE',
  USER_INTERACTION_FILTER = 'USER_INTERACTION_FILTER',
  USER_INTERACTION_COPY = 'USER_INTERACTION_COPY',
  USER_INTERACTION_FORM = 'USER_INTERACTION_FORM',
  USER_INTERACTION_AUTOFILL = 'USER_INTERACTION_AUTOFILL',
  USER_INTERACTION_CREATE = 'USER_INTERACTION_CREATE',
  USER_INTERACTION_PILLARS = 'USER_INTERACTION_PILLARS',
  MEMED_INTERACTION = 'MEMED_INTERACTION',
  CERTIFICATION_INTERACTION = 'CERTIFICATION_INTERACTION',

  //Errors
  INTERACTION_ERROR = 'INTERACTION_ERROR',
  FIRESTORE_ERROR = 'FIRESTORE_ERROR',
  FIREBASE_ERROR = 'FIREBASE_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  GOOGLE_MAPS_ERROR = 'GOOGLE_MAPS_ERROR'
}

export { EventModel, EventName }
export type { EventData, EventParams }
